/**
 * UTF-16 Little Endian Encoding.
 *
 * @group Utils
 *
 * @beta
 */
export const UTF_16_LE = 'utf-16le';
//# sourceMappingURL=UTF_16_LE.js.map